import { createFileRoute } from "@tanstack/react-router";
import { InvoicesTable } from "@/modules/invoices/table";

export const Route = createFileRoute("/dashboard/patients/$patientId/invoices")({
	component: RouteComponent,
});

function RouteComponent() {
	const { patientId } = Route.useParams();
	return <InvoicesTable patientId={patientId} />;
}
